import DataMapper from './DataMapper'
import Reminder from '../../models/Reminder'
import ReminderRM from '../responsemodel/ReminderRM'
import UserDataMapper from './UserDataMapper'

class ReminderDataMapper extends DataMapper<ReminderRM, Reminder> {
  private userDataMapper = new UserDataMapper()
  map = (rm: ReminderRM) => {
    const user:any = this.userDataMapper.map(rm.by)
    const closedBy = rm.closed_by ? this.userDataMapper.map(rm.closed_by) : null
    return new Reminder(rm.id, rm.text, user, rm.on, rm.valid_upto, rm.remaining_time, rm.active, closedBy, rm.closed_on, rm.postedOn)
  }
}

export default ReminderDataMapper
